export const standardAccountTypes = [
    "CTA CORRIENTE / CTA VISTA OTROS BANCOS",
    "CTA AHORRO",
    "CHEQUERA ELECTRÓNICA",
    "CUENTA RUT",
]
